<template>
  <b-form>
    <b-row>
      <b-col md="6">
        <b-form-group>
          <div>
            <span class="label-type-2 mr-2">Enable Service Fee</span>
            <div class="d-flex align-items-center">
              <switches
                v-model="selectedValue.enable_dine_in_service_fee"
                @input="$root.$emit('changesDetected')"
                theme="custom"
                color="primary"
                type-bold="true"
                style="top: 12px"
                :emit-on-mount="false"
              />
              <span class="ml-2">
                <small class="text-muted">{{
                  `${selectedValue.enable_dine_in_service_fee ? "Enabled" : "Disabled"}`
                }}</small>
              </span>
            </div>
          </div>
          <b-form-invalid-feedback :force-show="!isInvalid(`${origin}.enable_dine_in_service_fee`)">
            {{ errorMessage(`${origin}.enable_dine_in_service_fee`) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <div>
          <span class="label-type-2 mr-2">Service Fee Amount</span>
          <b-row>
            <b-col>
              <b-form-group label="Billing Type" label-class="grey">
                <div
                    class="mr-0 mr-lg-3 mb-3 mb-lg-0"
                  >
                    <b-form-select
                      v-model="selectedValue.dine_in_service_fee_unit"
                      :options="unitTypeOptions"
                      placeholder="-"
                      deselect-label=""
                      select-label=""
                      selected-label=""
                      :searchable="false"
                      :allow-empty="false"
                      :disabled="!selectedValue.enable_dine_in_service_fee"
                      @change="selectedValue.dine_in_service_fee_amount = selectedValue.dine_in_service_fee_unit == 'PHP' ? '0.00' : 0 "
                    />
                </div>
                <b-form-invalid-feedback :force-show="!isInvalid(`${origin}.dine_in_service_fee_unit`)">
                  {{ errorMessage(`${origin}.dine_in_service_fee_unit`) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Amount" label-class="grey">
                <template v-if="selectedValue.dine_in_service_fee_unit === '%'">
                  <percentage-input
                    v-model="selectedValue.dine_in_service_fee_amount"
                    :value="selectedValue.dine_in_service_fee_amount"
                    :disabled="!selectedValue.enable_dine_in_service_fee"
                    class-names="mr-0 mr-lg-3 mb-3 mb-lg-0 flex-grow-1"
                  />
                </template>
                <template v-else>
                  <currency-amount-input
                    v-model="selectedValue.dine_in_service_fee_amount"
                    :value="selectedValue.dine_in_service_fee_amount"
                    :disabled="!selectedValue.enable_dine_in_service_fee"
                    max-length="6"
                    class-names="mr-0 mr-lg-3 mb-3 mb-lg-0 flex-grow-1"
                  />
                </template>
                <b-form-invalid-feedback :force-show="!isInvalid(`${origin}.dine_in_service_fee_amount`)">
                  {{ errorMessage(`${origin}.dine_in_service_fee_amount`) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Switches from "vue-switches";
import CurrencyAmountInput from "@/components/common/CurrencyAmountInput";
import PercentageInput from "@/components/common/PercentageInput";

export default {
  name: "DineInFeeForm",
  props: ['selectedValue', 'origin'],
  components: { Switches, CurrencyAmountInput, PercentageInput },
  data() {
    return {
      oldValue: JSON.stringify(this.selectedValue),
      unitTypeOptions: [
        {
          value: 'PHP',
          text: 'Fixed amount'
        },
        {
          value: '%',
          text: '% of total bill'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      errors: "orderFulfillment/errors",
    }),
    ...mapState("accountProfile", ["detail"])
  },
  watch: {
    selectedValue: {
      handler() {
        const mustBeNumbers = [
          "dine_in_service_fee_amount"
        ];

        const transformedValues = JSON.parse(
          JSON.stringify(this.selectedValue)
        );

        Object.keys(this.selectedValue).forEach((key) => {
          if (mustBeNumbers.includes(key)) {
            if(!transformedValues[key]) this.selectedValue[key] = 0;
            transformedValues[key] = Number(
              this.selectedValue[key].toString().replace(/,/g, "")
            );
          }
        });

        if (this.oldValue !== JSON.stringify(transformedValues))
          this.$root.$emit("changesDetected");
      },
      deep: true,
    },
  },
  methods: {
    isInvalid(key) {
      return this.errors && this.errors[key] ? false : null;
    },
    errorMessage(key) {
      return this.errors && this.errors[key] ? this.errors[key] : null;
    }
  },
};
</script>

<style lang="scss" scoped>
.offset-top {
  position: relative;
  top: -3px;
}
.form-group {
  &.is-invalid {
    .input-group {
      border: solid 1px #dc3545;
      border-radius: 5px;
      .input-group-text,
      .form-control {
        border: 0;
      }
    }
  }
}
</style>

<style lang="scss">
@import url("../../assets/scss/fulfillment/_base.scss");
.col-form-label.grey {
  color: #68737d;
}
[id*="-fees-type"]
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::after {
  background: white;
  border-radius: 10px;
  width: 10px;
  height: 10px;
  top: 7px !important;
  left: -21px !important;
}
</style>
